import { Controller } from "@hotwired/stimulus"

/**
 * Automatically scrolls the frontend index search results into view.
 * Triggered when search or tag parameters are present in the URL.
 */
export default class extends Controller {
  connect() {
    if (!this.shouldScroll()) return

    requestAnimationFrame(() => {
      // Ensure the hash is present for direct linking/navigation.
      if (window.location.hash !== "#frontend-index-search") {
        window.location.hash = "frontend-index-search"
      }

      this.element.scrollIntoView({ block: "start" })
    })
  }

  /**
   * Checks if the current request is a search or a filtered index.
   * @returns {boolean}
   */
  shouldScroll() {
    const params = new URLSearchParams(window.location.search)
    return params.has("q") || params.has("tag")
  }
}
